var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c(
        "gg-card-header",
        {
          staticClass: "pb-0"
        },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  staticClass: "d-flex align-center",
                  attrs: {
                    md: "6",
                    cols: "12"
                  }
                },
                [
                  _c(
                    "gg-btn",
                    {
                      staticClass: "mr-2",
                      attrs: {
                        icon: ""
                      },
                      on: {
                        click: function click($event) {
                          return _vm.$emit("collapse")
                        }
                      }
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          attrs: {
                            color: "secondary"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.collapsed
                                ? "mdi-chevron-up"
                                : "mdi-chevron-down"
                            )
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-2",
                      attrs: {
                        size: "32px",
                        color: "primary"
                      }
                    },
                    [_vm._v("mdi-nas")]
                  ),
                  _vm._v(" " + _vm._s(_vm.groupName) + " "),
                  _c(
                    "v-chip",
                    {
                      staticClass: "ml-3",
                      attrs: {
                        small: ""
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.items.length) +
                          " " +
                          _vm._s(
                            _vm.items.length === 1 ? "website" : "websites"
                          ) +
                          " "
                      )
                    ]
                  ),
                  _c(
                    "v-chip",
                    {
                      staticClass: "ml-3",
                      attrs: {
                        small: "",
                        color: _vm.isActive ? "primary" : "warning"
                      }
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.isActive ? "Active" : "Inactive") + " "
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass:
                    "d-flex flex-sm-row flex-column justify-end align-start gap-sm align-md-center",
                  attrs: {
                    md: "6",
                    cols: "12"
                  }
                },
                [
                  _vm._t("header-actions"),
                  _c(
                    "gg-btn",
                    {
                      staticClass: "ml-3 text-none",
                      attrs: {
                        secondary: ""
                      },
                      on: {
                        click: function click($event) {
                          return _vm.navigateToSubAccount({
                            id: _vm.serviceId
                          })
                        }
                      }
                    },
                    [_vm._v(" Manage Plan ")]
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "gg-card-text",
        {
          staticClass: "px-0 py-0"
        },
        [
          _c(
            "v-expand-transition",
            [
              _c("v-data-table", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.collapsed,
                    expression: "!collapsed"
                  }
                ],
                staticClass: "rounded-xl",
                attrs: {
                  loading: _vm.loading,
                  headers: _vm.table.headers,
                  items: _vm.items,
                  "item-key": "virtualId",
                  "sort-by": "domain",
                  "footer-props": {
                    itemsPerPageOptions: _vm.pagination
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.domain",
                    fn: function fn(_ref) {
                      var item = _ref.item
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex items-center"
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                staticClass: "mr-2",
                                attrs: {
                                  size: "14",
                                  color: "primary"
                                }
                              },
                              [_vm._v("mdi-web")]
                            ),
                            _c("router-link", {
                              attrs: {
                                to: item,
                                custom: ""
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function fn(_ref2) {
                                      var navigate = _ref2.navigate
                                      return [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "ggs-item-title primary--text",
                                            attrs: {
                                              role: "link",
                                              "aria-label": "Manage"
                                            },
                                            on: {
                                              click: function click($event) {
                                                return _vm.navigateToSubAccount(
                                                  {
                                                    id: item.serviceId,
                                                    user: item.user
                                                  }
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(item.domain) + " "
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            }),
                            item.sharedaccount || item.sharedaccess
                              ? _c(
                                  "router-link",
                                  {
                                    staticClass: "pl-1",
                                    attrs: {
                                      to: {
                                        name: "profile_access"
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mb-1 ml-1",
                                        attrs: {
                                          small: ""
                                        }
                                      },
                                      [_vm._v("mdi-account-multiple")]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "v-icon",
                              {
                                staticClass: "ml-2",
                                attrs: {
                                  color: "grey darken-3",
                                  size: "12"
                                }
                              },
                              [_vm._v("mdi-open-in-new")]
                            )
                          ],
                          1
                        )
                      ]
                    }
                  },
                  {
                    key: "item.domaintype",
                    fn: function fn(_ref3) {
                      var item = _ref3.item
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.DOMAIN_TYPE_NAMES[item.domaintype]) +
                            " "
                        )
                      ]
                    }
                  },
                  {
                    key: "item.flag",
                    fn: function fn(_ref4) {
                      var item = _ref4.item
                      return [
                        _c(
                          "v-icon",
                          {
                            staticClass: "mr-1 caption"
                          },
                          [_vm._v(_vm._s(_vm.iconFlag(item.flag)))]
                        ),
                        _vm._v(" " + _vm._s(item.flag) + " ")
                      ]
                    }
                  },
                  {
                    key: "item.status",
                    fn: function fn(_ref5) {
                      var item = _ref5.item
                      return [
                        _c(
                          "div",
                          [
                            _c(
                              "v-icon",
                              {
                                staticClass: "pb-1",
                                attrs: {
                                  small: "",
                                  color: _vm.statusColor(item.status)
                                }
                              },
                              [_vm._v("mdi-circle")]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "pl-1"
                              },
                              [_vm._v(_vm._s(item.status))]
                            )
                          ],
                          1
                        )
                      ]
                    }
                  },
                  {
                    key: "item.actions",
                    fn: function fn(_ref6) {
                      var item = _ref6.item
                      return [
                        _c(
                          "gg-btn",
                          {
                            staticClass: "mr-1",
                            on: {
                              click: function click($event) {
                                return _vm.navigateToSubAccount({
                                  id: item.serviceId,
                                  user: item.user
                                })
                              }
                            }
                          },
                          [_vm._v(" Manage ")]
                        ),
                        item.type === _vm.SERVICE_TYPES.CPANEL ||
                        item.type === _vm.SERVICE_TYPES.RESELLER
                          ? _c(
                              "gg-btn",
                              {
                                staticClass: "mr-1",
                                attrs: {
                                  to: _vm.createEmailUrl(item),
                                  secondary: ""
                                }
                              },
                              [_vm._v(" Email ")]
                            )
                          : _vm._e(),
                        item.wp_insid
                          ? _c(
                              "gg-btn",
                              {
                                staticClass: "mr-1",
                                attrs: {
                                  to: _vm.createWpUrl(item),
                                  secondary: ""
                                }
                              },
                              [_vm._v(" WordPress ")]
                            )
                          : _vm._e(),
                        item.type === _vm.SERVICE_TYPES.CPANEL ||
                        item.type === _vm.SERVICE_TYPES.RESELLER
                          ? _c(
                              "gg-btn",
                              {
                                staticClass: "mr-1 text-none",
                                attrs: {
                                  secondary: ""
                                },
                                on: {
                                  click: function click($event) {
                                    return _vm.launch_cpanel(
                                      item.serviceId,
                                      item.username
                                    )
                                  }
                                }
                              },
                              [_vm._v(" cPanel ")]
                            )
                          : _vm._e(),
                        item.type === _vm.SERVICE_TYPES.RESELLER
                          ? _c(
                              "gg-btn",
                              {
                                staticClass: "mr-1",
                                attrs: {
                                  secondary: ""
                                },
                                on: {
                                  click: function click($event) {
                                    return _vm.launch_whm(item.serviceId)
                                  }
                                }
                              },
                              [_vm._v(" WHM ")]
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }